export default __webpack_public_path__ + "static/media/bet-and-earn-banner-indon.93051411.webp";